/**
 * Bulk actions above a rules list: select, copy, delete, new.
 * For Media Devoted | Created By Ciro Autiero
 *
 * Extracted from TagRuleTabContent, which had grown well past the file limit —
 * these buttons are self-contained and share nothing with the list but callbacks.
 */

import type { FC } from 'react';
import { Copy, Plus, Trash2 } from 'lucide-react';

import { Button } from '@/components/ui';

export const RulesToolbar: FC<{
  hasRules: boolean;
  selectedCount: number;
  allSelected: boolean;
  busy: boolean;
  onSelectAll: () => void;
  onCopy: () => void;
  onDeleteSelected: () => void;
  onDeleteAll: () => void;
  onNew: () => void;
}> = ({
  hasRules,
  selectedCount,
  allSelected,
  busy,
  onSelectAll,
  onCopy,
  onDeleteSelected,
  onDeleteAll,
  onNew,
}) => (
  <div className="flex flex-wrap items-center gap-2">
    {hasRules && (
      <>
        <Button variant="outline" size="sm" onClick={onSelectAll} disabled={busy}>
          {allSelected ? 'Deselect all' : 'Select all'}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onCopy}
          disabled={busy}
          title="Copy rules as JSON for AI prompt or bulk import"
        >
          <Copy className="mr-1.5 h-4 w-4" />
          Copy {selectedCount > 0 ? `${selectedCount} ` : ''}rules
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onDeleteSelected}
          disabled={selectedCount === 0 || busy}
          className="text-destructive hover:bg-destructive/10 hover:text-destructive"
        >
          <Trash2 className="mr-1.5 h-4 w-4" />
          Delete selected
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onDeleteAll}
          disabled={busy}
          className="text-destructive hover:bg-destructive/10 hover:text-destructive"
        >
          <Trash2 className="mr-1.5 h-4 w-4" />
          Delete all
        </Button>
      </>
    )}
    <Button onClick={onNew}>
      <Plus className="mr-2 h-4 w-4" />
      New rule
    </Button>
  </div>
);
